<template>
    <div class="gallery">
        <div class="main-image-wrap">
            <div class="type-switch" v-if="filmId && images.length">
                <div class="video" @click="type = 'VIDEO'" :class="{'active': type === 'VIDEO'}">
                    影片
                </div>
                <div class="image" @click="type = 'IMAGE'" :class="{'active': type === 'IMAGE'}">
                    圖片
                </div>
            </div>
            <div class="current-page">
                {{currentIndex}}/{{sliderCount}}
            </div>
            <VueSlickCarousel
                class="main-image"
                ref="c1"
                :focusOnSelect="false"
                :fade="true"
                :arrows="false"
                @afterChange="chageIndex"
            >
                <iframe v-if="filmId" width="100%" height="100%" :src="'https://www.youtube.com/embed/'+filmId" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <div v-for="(item, index) in images" :key="index">
                    <img :src="imageUrl(item)" alt="" srcset="">
                </div>
            </VueSlickCarousel>
        </div>
        <div class="thumb-wrap">
            <div class="prev" @click="showPrev()">
                <img src="@/assets/img/shareHouse/prev.svg" alt="">
            </div>
            <div class="next" @click="showNext()">
                <img src="@/assets/img/shareHouse/next.svg" alt="">
            </div>
            <VueSlickCarousel
                class="thumb"
                ref="c2"
                :slidesToShow="5"
                :focusOnSelect="true"
                :arrows="false"
            >
                <div v-if="filmId"  class="thumb-video">
                    <div class="mask"></div>
                    <iframe width="100%" height="100%" :src="'https://www.youtube.com/embed/'+filmId" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div v-for="(item, index) in images" :key="index" @click="getNavIndex(index)">
                    <img :src="imageUrl(item)" alt="" srcset="">
                </div>
            </VueSlickCarousel>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import constant from '@/constant'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        data () {
            return {
                currentIndex: 1,
                type: 'VIDEO'
            }
        },
        mounted () {
            console.log(this.images)
            setTimeout(()=>{
                // console.log(this.$refs)
                this.$refs.c1.asNavFor =this.$refs.c2
                this.$refs.c2.asNavFor =this.$refs.c1
            },1000)
            
        },
        watch: {
            type: function (val){
                console.log(val)
                if(val === 'VIDEO'){
                    this.$refs.c2.goTo(0)
                    this.currentIndex = 1
                }else if(val === 'IMAGE'){
                    this.$refs.c2.goTo(1)
                    this.currentIndex = 2
                }
            },
            currentIndex: function (val){
                if(this.filmId && this.images.length){
                    if(val === 1){
                        this.type = 'VIDEO'
                    }else{
                        this.type = 'IMAGE'
                    }
                }
            }
        },
        methods: {
            showNext() {
                this.$refs.c2.next()
                // this.currentIndex += 1
                // if( this.currentIndex >= this.images.length){
                //     this.currentIndex = 1
                // }
            },
            showPrev() {
                this.$refs.c2.prev()
                // this.currentIndex -= 1
                // if( this.currentIndex < 1){
                //     this.currentIndex = this.images.length
                // }
            },
            chageIndex: function (slideIndex) {
                this.currentIndex = slideIndex+1
            },
            getNavIndex(index) {
                this.currentIndex = index
            },
            imageUrl: function (url) {
                return constant.imageUrl+url
            },
        },
        computed: {
            sliderCount: function () {
                if(this.filmId && this.images.length){
                    return this.images.length+1
                }else if(this.filmId){
                    return 1
                }else{
                    return this.images.length
                }
            },
            ...mapGetters({
                images: 'GET_SHARE_HOUSE_IMAGES',
                filmId: 'GET_SHARE_HOUSE_VIDEO'
            })
        },
        components: { 
            VueSlickCarousel 
        },
    }
</script>
<style lang="scss">
    .gallery{
        position: relative;
        // margin: -10px;
        * {
            outline-style: none
        }
        .main-image-wrap{
            position: relative;
            margin-bottom: 14px;
            .type-switch{
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4.6px;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 2;
                bottom: 24px;
                left: 50%;
                transform: translateX(-50%);
                color: #fff;
                >div{
                    padding: 6px 8px;
                    border-radius: 4.6px;
                    letter-spacing: 1px;
                    cursor: pointer;
                    transition-duration: .4s;
                    &.active{
                        background-color: #fb6b63;
                    }
                }
            }
            .current-page{
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 63px;
                height: 28px;
                border-radius: 4.1px;
                background-color: rgba(0, 0, 0, 0.8);
                color: #fff;
                font-size: 16px;
                letter-spacing: 1.14px;
                bottom: 24px;
                right: 20px;
                z-index: 2;
            }
            .main-image{
                .slick-slide{
                    width: 100%;
                    max-height: 450px;
                    height: calc(100vw * 450.0 / 1280.0);
                    // height: 528px;
                    border-radius: 8px;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    >div{
                        position: relative;
                        width: 100%;
                        height: 100%;
                        z-index: 5;

                    }
                    img{
                        width: 100%;
                        border-radius: 8px;
                    }
                }
            }
        }
        
        .thumb-wrap{
            position: relative;
            .prev,
            .next{
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 34px;
                height: 34px;
                box-shadow: 0 0 4px 0 rgba(136, 136, 136, 0.5);
                background-color: rgba(255, 255, 255, 0.75);
                border-radius: 17px;
                top: 50%;
                transform: translateY(-17px);
                z-index: 2;
                cursor: pointer;
                
            }
            .prev{
                left: -17px;
            }
            .next{
                right: -17px;
            }
            .thumb{
                margin: -10px;
                .thumb-video{
                    position: relative;
                    .mask{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        z-index: 4;
                    }
                }
                .slick-slide{
                    border-radius: 2px;
                    overflow: hidden;
                    // height: 93px;
                    >div{
                        margin: 10px;
                        cursor: pointer;
                        >div{
                            border-radius: 2px;
                            height: 94px;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    img{
                        width: 134%;
                        border-radius: 2px;
                    }
                }
                .slick-current{
                    >div{
                        >div{
                            border: solid 2px #fb6b63;
                        }
                    }
                }
            }
        }
        
    }
    @media (max-width: 992px) {
        .gallery{
            .main-image-wrap{
                margin-bottom: 0px;
                .type-switch{
                    bottom: 40px;
                }
                .current-page{
                    width: 58px;
                    height: 24px;
                    border-radius: 4px;
                    background-color: rgba(0, 0, 0, 0.5);
                    font-size: 14px;
                    letter-spacing: 1;
                    bottom: 40px;
                    right: unset;
                    left: 15px;
                }
                .main-image{
                    .slick-slide{
                        width: 100%;
                        max-height: 450px;
                        height: calc(100vw * 450.0 / 992.0);
                        // height: 528px;
                        border-radius: 0px;
                        img{
                            border-radius: 0px;
                        }
                    }
                }
            }
            .thumb-wrap{
                .prev,
                .next{
                    display: none;
                }
                .thumb{
                    display: none;
                }
            }
            
        }
    }
    @media (max-width: 576px) {
        .gallery{
            margin-left: -20px;
            margin-right: -20px;
            .main-image-wrap{
                .main-image{
                    .slick-slide{
                        height: calc(100vw * 450.0 / 596.0);
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/houseSlider.vue